// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailC":"C_d2xDetailC__Hncps"};